export const SIGNALS_TIME_RANGES = ['1M', '3M', '6M', '12M', 'All'] as const;
export type SignalsTimeRange = (typeof SIGNALS_TIME_RANGES)[number];

/**
 * `limit_per_asset` value to pass to the CoinMetrics timeseries endpoint for each range.
 * `null` means no limit — the full asset history is requested.
 */
export const SIGNALS_TIME_RANGE_LIMIT: Record<SignalsTimeRange, number | null> = {
  '1M': 30,
  '3M': 90,
  '6M': 180,
  '12M': 365,
  All: null,
};

export const SIGNALS_DEFAULT_TIME_RANGE: SignalsTimeRange = 'All';

/** CoinMetrics hard cap on `page_size`. A single page covers the full daily history of any asset. */
export const CM_MAX_PAGE_SIZE = 10_000;
/**
 * `limit_per_asset` used when fetching the maximum history upfront so that time-range
 * changes are handled client-side and never trigger a re-fetch.
 */
export const CM_FETCH_LIMIT_PER_ASSET = 365 * 20;

// Wide enough that the asset summary shows the leading symbols before collapsing to "+N",
// and the metric value isn't cramped.
// However, this has to be reconsidered when we do mobile views for these modules.
export const ASSET_CONTROL_WIDTH = '200px';
export const METRIC_CONTROL_WIDTH = '200px';
